import { WebsiteCreateInterface, WebsiteErrorsInterface } from '../types/website-interface'

export const websiteDefaultErrors: WebsiteErrorsInterface = {
  name: '',
  homePagePath: '',
  domainId: '',
  locale: '',
  path: '',
}

export const websiteDefaultCreateValues: WebsiteCreateInterface = {
  name: '',
  homePagePath: '',
  domainId: null,
  locale: undefined,
}
